"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var profile_components_1 = require("@l2p/profile-components");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var Lockr = __importStar(require("lockr"));
var react_1 = __importStar(require("react"));
var LeavingSoSoon_1 = __importDefault(require("./LeavingSoSoon"));
var DELAY_SHOW_LEAVING_BONUS = 'delayShowLeavingBonus';
var DepositModal = function (_a) {
    var paymentSettings = _a.paymentSettings;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var _b = (0, swr_hooks_1.useDepositCurrentBonus)(), depositCurrentBonus = _b.depositCurrentBonus, changeDepositCurrentBonus = _b.changeDepositCurrentBonus;
    var config = (0, swr_hooks_1.useConfig)();
    var closeModal = (0, apps_shared_1.useCloseModal)(true);
    var delayShowLeavingBonus = typeof window !== 'undefined' && Lockr.get(DELAY_SHOW_LEAVING_BONUS);
    var _c = (0, react_1.useState)(false), isOpenLeaving = _c[0], setIsOpenLeaving = _c[1];
    var onCloseModal = (0, react_1.useCallback)(function () {
        var delayEnd = !delayShowLeavingBonus ||
            delayShowLeavingBonus.expire < new Date().getTime();
        if (depositCurrentBonus && delayEnd) {
            setIsOpenLeaving(true);
            Lockr.rm(DELAY_SHOW_LEAVING_BONUS);
        }
        else {
            closeModal();
        }
    }, [delayShowLeavingBonus, closeModal, depositCurrentBonus]);
    (0, react_1.useEffect)(function () {
        changeDepositCurrentBonus(null);
        /*eslint-disable-next-line*/
    }, []);
    return (react_1.default.createElement(ui_components_1.Modal, { width: "100%", padding: "0", id: "deposit-modal", onClose: onCloseModal, overflowY: !(breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile) ? 'auto' : 'initial', showClose: !(breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile), style: {
            touchAction: (breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile) ? 'none' : 'auto',
            pointerEvents: 'auto',
            maxWidth: '960px',
        } },
        react_1.default.createElement(profile_components_1.PaymentsWithSwitch, { paymentSettings: paymentSettings, isModal: true, onCloseModal: onCloseModal }),
        depositCurrentBonus && isOpenLeaving && (react_1.default.createElement(LeavingSoSoon_1.default, { leavingBonus: depositCurrentBonus, onClose: function () {
                setIsOpenLeaving(false);
            }, onCancel: function () {
                if (config === null || config === void 0 ? void 0 : config.depositLeavingBonusDelay) {
                    Lockr.set(DELAY_SHOW_LEAVING_BONUS, {
                        expire: new Date().getTime() + config.depositLeavingBonusDelay,
                    });
                }
                setIsOpenLeaving(false);
                closeModal();
            } }))));
};
exports.default = DepositModal;
